import Auth from '../../utils/Auth';

module.exports = [
	{
		path: 'email-verified',
		getComponent(nextState, cb) {
			require.ensure([], (require) => {
				cb(null, require('./components/EmailVerified'));
			});
		}
	},
	{
		path: 'confirm-email',
		getComponent(nextState, cb) {
			require.ensure([], (require) => {
				cb(null, require('./components/ConfirmEmail'));
			});
		}
	},
	{
		path: 'forgot-password',
		getComponent(nextState, cb) {
			require.ensure([], (require) => {
				cb(null, require('./components/ForgotPassword'));
			});
		}
	},
	{
		path: 'reset-password',
		getComponent(nextState, cb) {
			require.ensure([], (require) => {
				cb(null, require('./components/ResetPassword'));
			});
		}
	},
	{
		path: 'login',
		getComponent(nextState, cb) {
			require.ensure([], (require) => {
				cb(null, require('./components/Login'));
			});
		}
	},
	// {
	// 	path: 'sign-up',
	// 	getComponent(nextState, cb) {
	// 		require.ensure([], (require) => {
	// 			cb(null, require('./components/SignUp'));
	// 		});
	// 	}
	// },
	// {
	// 	path: 'sign-up-c',
	// 	getComponent(nextState, cb) {
	// 		require.ensure([], (require) => {
	// 			cb(null, require('./components/SignUp'));
	// 		});
	// 	}
	// },
	{
		path: 'confirm_usage_ld',
		getComponent(nextState, cb) {
			require.ensure([], (require) => {
				cb(null, require('./components/Usage'));
			});
		}
	}
];



// WEBPACK FOOTER //
// ./routes/auth/index.js